// extracted by mini-css-extract-plugin
export var content = "notfound-module--content--qi2Dd";
export var image = "notfound-module--image--DTVLi";
export var notFound = "notfound-module--not-found--AgTek";
export var title = "notfound-module--title--6XHTM";